"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccountData = void 0;
const useStore_1 = require("root/src/client/logic/helpers/useStore");
function useAccountData() {
    return (0, useStore_1.useAppSelector)(state => { var _a, _b; return (_b = (_a = state === null || state === void 0 ? void 0 : state.app) === null || _a === void 0 ? void 0 : _a.userData) === null || _b === void 0 ? void 0 : _b.accountData; });
}
exports.useAccountData = useAccountData;
